import { isNavigationFailure } from 'vue-router';

const SENSITIVE_DATA_KEY =
  /(?:^|[._-])(args?|arguments?|authorization|body|cookies?|credentials?|email|headers?|params?|password|payload|phone|post_data|query|query_string|secrets?|sentry_user|sql|statement|tokens?)(?:$|[._-])/i;
const URL_DATA_KEY =
  /(?:^|[._-])(destination|endpoint|from|location|target|to|uri|url)(?:$|[._-])/i;

const withoutQueryOrFragment = value =>
  typeof value === 'string' ? value.split(/[?#]/, 1)[0] : value;

const sanitizeData = data => {
  if (!data || typeof data !== 'object') return;

  Object.keys(data).forEach(key => {
    if (SENSITIVE_DATA_KEY.test(key)) {
      delete data[key];
    } else if (URL_DATA_KEY.test(key) && typeof data[key] === 'string') {
      data[key] = withoutQueryOrFragment(data[key]);
    } else {
      sanitizeData(data[key]);
    }
  });
};

export const sanitizeSentryEvent = event => {
  delete event.user;
  event.transaction = withoutQueryOrFragment(event.transaction);

  if (event.request) {
    event.request.url = withoutQueryOrFragment(event.request.url);
    delete event.request.cookies;
    delete event.request.data;
    delete event.request.headers;
    delete event.request.query_string;
  }

  event.breadcrumbs?.forEach(breadcrumb => {
    sanitizeData(breadcrumb.data);
    if (/^(fetch|http|xhr)/i.test(breadcrumb.category || '')) {
      breadcrumb.message = withoutQueryOrFragment(breadcrumb.message);
    }
  });

  event.spans?.forEach(span => {
    span.description = withoutQueryOrFragment(span.description);
    sanitizeData(span.data);
  });
  sanitizeData(event.contexts);
  sanitizeData(event.extra);
  sanitizeData(event.tags);
  if (event.contexts?.account) delete event.contexts.account.name;

  return event;
};

export const beforeSendSentryEvent = (event, hint) =>
  isNavigationFailure(hint.originalException)
    ? null
    : sanitizeSentryEvent(event);

export const isExpectedNavigationFailure = error => isNavigationFailure(error);
